export default "__VITE_ASSET__CPLUECKX__"